import Fetch from "../script/Fetch";
import servicesProvider from "./ServicesProvider";

export class TilbyService {
    async insertRistoranteTilbyWithApiKey(ristoranteId: string, apiKey: string) {
        try {
            return await Fetch.doFetch(`/tilby/${ristoranteId}/apiKey`, {
                method: "POST",
                body: {
                    apiKey: apiKey
                }
            });
        } catch (error: any) {
            throw new Error("Errore durante l'upload del menu su tilby.");
        }
    }

    async insertTilbyTavoloList(ristoranteId: string) {
        try {
            return await Fetch.doFetch(`/tilby/${ristoranteId}/tavoloList`, {
                method: "POST"
            });
        } catch (error: any) {
            throw new Error("Errore durante l'upload del menu su tilby.");
        }
    }

    async downloadSalesByRange(ristoranteId: string, startDate: string, endDate: string) {
        try {
            return await Fetch.doFetch(`/tilby/${ristoranteId}/sales`, {
                method: "POST",
                body: {
                    startDate: startDate,
                    endDate: endDate,
                    isFirst: true
                }
            });
        } catch (error: any) {
            throw new Error("Errore durante l'upload del menu su tilby.");
        }
    }
}